<template>
  <div>
    <c-row>
      <c-col col="12">
        <c-card>
          <loader v-show="loading" />
          <c-card-header>
            <strong>Transaksi dalam proses</strong>
            <div class="card-header-actions">
              <CInput
                @keyup="doSearch"
                type="text"
                placeholder="Ketikan sesuatu kemudian tekan enter"
                v-model="q"
                style="width: 400px"
                ref="search"
              ></CInput>
            </div>
          </c-card-header>
          <c-card-body style="overflow: auto">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th width="50px">No</th>
                  <th>Faktur</th>
                  <th>Invoice</th>
                  <th>Customer</th>
                  <th>Created By</th>
                  <th>Created At</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in data.data" :key="k">
                  <td class="center">
                    <table-number
                      v-if="data.paginate"
                      :size="data.paginate.per_page"
                      :page="page"
                      :index="k"
                    />
                  </td>
                  <td>{{ d.faktur }}</td>
                  <td>{{ d.invoice }}</td>
                  <td>{{ d.customer_name }}</td>
                  <td>{{ d.user_name }}</td>
                  <td align="center">{{ d.created_at | dateTimeFormat }}</td>
                  <td align="center">
                    <label class="label bg-primary" v-show="d.status == 1"
                      >Pending</label
                    >
                    <label class="label bg-warning" v-show="d.status == 3"
                      >Perubahan</label
                    >
                  </td>
                  <td align="center" width="90">
                    <CButton
                      class="btn-outline-info btn btn-action"
                      v-c-tooltip.hover.click="'Preview'"
                      @click="doPreview(d.id)"
                    >
                      <i class="cil-magnifying-glass"></i>
                    </CButton>
                    <CButton
                      class="btn-outline-success btn btn-action"
                      v-c-tooltip.hover.click="'Approve'"
                      @click="doApprove(d)"
                    >
                      <i class="cil-check"></i>
                    </CButton>
                    <CButton
                      v-if="d.status == 3"
                      class="btn-outline-warning btn btn-action"
                      v-c-tooltip.hover.click="'Compare'"
                      @click="doCompare(d.id)"
                    >
                      <i class="cil-copy"></i>
                    </CButton>
                    <CButton
                      class="btn-outline-danger btn btn-action"
                      v-c-tooltip.hover.click="'Delete'"
                      @click="delConfirm(d)"
                    >
                      <i class="cil-trash"></i>
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
          <c-card-footer>
            <CPagination
              v-if="data.paginate"
              align="end"
              :active-page.sync="page"
              :pages="Math.ceil(data.paginate.total / data.paginate.per_page)"
              responsive
            />
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
    <CModal
      title="Approve Confirmation"
      size="sm"
      color="success"
      :show.sync="approveConfirmation"
    >
      Yakin menyetujui transaksi
      <span v-if="approveItem">"{{ approveItem.faktur }}"</span> ?
      <template #footer>
        <CButton @click="approveConfirmation = false" color="danger"
          >Batal</CButton
        >
        <CButton @click="runApprove" color="success">Yakin</CButton>
      </template>
    </CModal>
    <CModal
      title="Delete Confirmation"
      size="sm"
      color="danger"
      :show.sync="deleteConfirm"
    >
      Yakin Akan menghapus data ?
      <textarea
        placeholder="alasan dihapus (max: 200)"
        class="form-control"
        v-model="delReason"
        maxlength="200"
      />
      <template #footer>
        <CButton @click="deleteConfirm = false" color="danger">Batal</CButton>
        <CButton @click="runDelete" color="success">Yakin</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import Loader from "../../components/Loader";
import TableNumber from "../../components/TableNumber";
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: {
    TableNumber,
    Loader,
  },
  data () {
    return {
      q: "",
      data: {},
      approveConfirmation: false,
      approveItem: {},
      page: 1,
      loading: true,
      deleteConfirm: false,
      delObject: {},
      delReason: ''
    };
  },
  created () {
    this.getData("");
  },
  methods: {
    getData (q) {
      this.loading = true;
      HTTPAUTH.get(
        `/api/v1/sale/process?size=10&page=${this.page}&q=${q}`
      ).then((res) => {
        this.data = res.data;
        this.page = res.data.paginate.page;
        this.loading = false;
      }).catch(eres => {
        showErrorMessage(eres)
        this.loading = false;
      });
    },
    doSearch (e) {
      if (e.keyCode == 13) {
        this.getData(this.q);
      }
    },
    doPreview (id) {
      this.$router.push({
        path: `/print-preview/kasir/faktur/${id}?preview=true&rollback=/kasir/process&printurl=/print/kasir/faktur`,
      });
    },
    doApprove (i) {
      this.approveConfirmation = true;
      this.approveItem = i;
    },
    runApprove () {
      this.loading = true;
      this.approveConfirmation = false;
      HTTPAUTH.put("/api/v1/sale/" + this.approveItem.id)
        .then(() => {
          this.$toasted.success("Berhasil").goAway(3000);
          this.getData("");
          this.loading = false;
        })
        .catch((eres) => {
          this.$toasted.error(eres.response.data.user_message).goAway(3000);
          this.loading = false;
        });
    },
    doCompare (id) {
      this.$router.push({ path: "/kasir/compare/" + id });
    },
    runDelete () {
      HTTPAUTH.delete(`/api/v1/sale/${this.delObject.id}?r=${this.delReason}`)
        .then(() => {
          this.$toasted.success("Hapus data berhasil").goAway(3000);
          this.deleteConfirm = false;
          this.delReason = '';
          this.getData('');
        })
        .catch(eres => {
          this.$toasted.error(eres.response.statusText).goAway(3000);
          this.deleteConfirm = false;
          this.delReason = '';
          this.getData('');
        });
    },
    delConfirm (o) {
      this.delObject = o
      this.deleteConfirm = true
    }
  },
  watch: {
    page (p) {
      this.$router.push({ query: { page: p } });
      this.getData("");
    },
  },
};
</script>